import deleteAttachmentOperation from 'owa-service/lib/operation/deleteAttachmentOperation';
import getChangedAttachmentIds from '../utils/getChangedAttachmentIds';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { ClientAttachmentId } from 'owa-client-ids';
import { discardAddedAttachments } from 'owa-calendar-compose-form-actions';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { orchestrator } from 'satcheljs';
import { getMailboxRequestOptions } from 'owa-request-options-types';

export default orchestrator(discardAddedAttachments, async actionMessage => {
    const { event, originalEvent } = getComposeStore();
    const { addedAttachmentIds } = getChangedAttachmentIds(event, originalEvent);
    if (addedAttachmentIds.length > 0) {
        await deleteAttachments(addedAttachmentIds);
    }
});

async function deleteAttachments(attachmentIds: ClientAttachmentId[]): Promise<void> {
    await deleteAttachmentOperation(
        {
            Header: getJsonRequestHeader(),
            Body: {
                ClientSupportsIrm: true,
                AttachmentIds: attachmentIds,
            },
        },
        getMailboxRequestOptions(attachmentIds[0].mailboxInfo)
    );
}
